import type { TOC } from '@ember/component/template-only';

interface GeneralSmartInsightsDetailViewSmartInsightCardSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

<template>
  <div
    class="bg-general-neutral-00 rounded-200 flex flex-col shadow-neutral-100"
    ...attributes
  >
    {{yield}}
  </div>
</template> satisfies TOC<GeneralSmartInsightsDetailViewSmartInsightCardSignature>;
